import {
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Type,
  ViewContainerRef
} from "@angular/core";
import {BaseDialog} from "../system/admin-panel/BaseDialog";

@Injectable()
export class DialogService {

  constructor(private resolver: ComponentFactoryResolver) {
  }

  public open<T>(container:ViewContainerRef,componentType:Type<BaseDialog>):ComponentRef<any> {
    container.clear();
    const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(componentType);
    let result = container.createComponent(factory);
    result.instance.onClose.subscribe(() => {
      result.destroy()
    });
    result.instance.onSubmit.subscribe(() => {
      result.destroy()
    });
    return result;
  }
}
